export enum DatabaseSections {
  CUSTOMER = "customers",
  DOCUMENTS = "documents",
  JOBS = "jobs",
  CONTACTS = "contacts",
  NOTES = "notes",
  ORDERS = "orders",
  MATERIALS = "materials",
  QUARRY = "quarry",
}

export enum ModalModes {
  EDIT = "edit",
  CREATE = "create",
}

export enum JobStatus {
  NOT_APPROVED = "Not Approved",
  APPROVED = "Approved",
  CLOSED = "Closed",
}

export enum DocumentTypes {
  CONTRACT = "Contract",
  INSURANCE = "Insurance",
  OTHERS = "Others",
}

export enum JobOrderType {
  TRUCKING_JOB = "Trucking Job",
  TRUCKING_MATERIAL_JOB = "Trucking & Material Job",
  BOTH = "Both",
}

export enum JobDatabaseFilterType {
  JOB_NUMBER = "jobNumber",
  JOB_NAME = "jobName",
  CUSTOMER = "customer",
  JOB_TYPE = "jobType",
  EQUIPMENT = "equipment",
  MATERIAL_CATEGORY = "materialCategory",
  MATERIAL_TYPE = "materialType",
  SALES_PERSON = "salesPerson",
}

export enum DatabaseMetricsKey {
  JOB_METRICS = "jobMetrics",
  QUARRY_METRICS = "quarryMetrics",
}
export enum QuantityTypeEnum {
  TON = "Ton",
  HOUR = "Hour",
}

export enum materialProfile {
  CATEGORY = "category",
  SUB_CATEGORY = "subCategory",
  MATERIAL = "material",
  MATERIAL_NAME = "materialValues",
}

export enum DatabaseMetaKeys {
  PAGINATION = 'pagination',
}